var map = {
	"./api.png": "1051",
	"./document.png": "76a7",
	"./facebook.png": "d2ba",
	"./ins.png": "9a9e",
	"./news.png": "6b47",
	"./tg.png": "d977",
	"./toutiao.png": "7849",
	"./twitter.png": "df1c",
	"./vk.png": "55df",
	"./wechat.png": "baea",
	"./weibo.png": "d24f",
	"./youtube.png": "f55b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a743";